import type { HelpFile } from '../../types/help'
import { SapHcmInboundConfigEditDialogTestIds } from '../../../testids/SapHcmInboundConfigEditDialogTestIds'

export const sapHcmInboundConfigEditDialogHelp: HelpFile = {
  docPage: '/docs/connectors/sap-hcm-connector',
  texts: {
    [SapHcmInboundConfigEditDialogTestIds.btnCancelSapHcmConfig]: null,
    [SapHcmInboundConfigEditDialogTestIds.btnSaveSapHcmConfig]: null,
    [SapHcmInboundConfigEditDialogTestIds.selectSapHcmAuthType]:
      'Authentication scheme for the SAP HCM OData V2 endpoint. Defaults to BASIC for SAP-internal users; switch to OAUTH2_CLIENT when the gateway exposes a token endpoint.',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmEmployeeKeyField]:
      'Wire field carrying the per-employee key. Canonical SAP HCM is PERNR; override (e.g. to mitarbeiterNummer) when a German PDQ wrapper or other custom envelope renames the employee identifier.',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmValidityStartField]:
      'Wire field name for the validity-band start date (typically BEGDA in canonical SAP HCM).',
    [SapHcmInboundConfigEditDialogTestIds.inputSapHcmValidityEndField]:
      'Wire field name for the validity-band end date (typically ENDDA in canonical SAP HCM).',
    [SapHcmInboundConfigEditDialogTestIds.sapHcmValiditySelect]:
      'Validity-band resolution mode: AS_OF_TODAY picks the band valid right now; LATEST picks the most recently valid band; ALL emits one record per band.',
  },
}
